<template>
  <div id="app" class="main-content dashboard">
    <div class="row">
      <div class="dash-item col-sm-6">
        <router-link slot="item-title" to="/funder/clients">
          <div class="dashbox">
            <div class="desc">
              <span v-if="isLoaded" class="amount" >{{ getContacts }}</span>
              <span class="title">{{ $t('dashboard.cards.clients') }} </span>
            </div>
            <div class="icon">
              <contact-icon class="card-icon" />
            </div>
          </div>
        </router-link>
      </div>
      <div class="dash-item col-sm-6">
        <router-link slot="item-title" to="/funder/invoices">
          <div class="dashbox">
            <div class="desc">
              <span v-if="isLoaded" class="amount">{{ getInvoices }}</span>
              <span class="title">{{ $t('dashboard.cards.invoices') }}</span>
            </div>
            <div class="icon">
              <invoice-icon class="card-icon" />
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 mt-2">
        <div class="card dashboard-card">
          <div class="graph-body">
            <div class="card-body col-md-12 col-lg-12 col-xl-10">
  <div class="card-header">
    <div class="col-md-6">
      <h6><i class="fa fa-line-chart text-primary"/>
        {{ $tc('dashboard.invoice_chart.title', 2) }}
      </h6>
    </div>
    <div class="col-md-3">
      <h6><i class="fa fa-line-chart text-primary"/>
        {{ $tc('dashboard.credit_limit.title', 2) }}
      </h6>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-3">
      <base-select
        v-model="selectedCustomer"
        :options="customerOption"
        :searchable="true"
        :show-labels="false"
        :allow-empty="true"
        :tabindex="8"
        :placeholder="$t('dashboard.select_client')"
        label="company_name"
        track-by="id"
      />
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <bar-chart
        v-if="isLoaded"
        :label="'Invoices'"
        :labels="labels"
        :values="invoiceGroupCount"
        :backgroundColor="bgColors"
        :borderColor="bgColors"
        :hoverBackgroundColor="bgColors"
        :hoverBorderColor="bgColors"
        :updateChart="updateChart"
      />
    </div>
    <div class="col-md-6">
      <p class="text-center"> Total Credit Limit <span v-html="$utils.formatMoney(total_credit_limit, defaultCurrency)"/></p>
      <pie-chart
        v-if="isLoaded"
        :labels="CreditLimitLabels"
        :values="CreditLimitData"
        :bgColors="bgCreditLimitColors"
        :hoverBgColors="hoverBgColors"
        :type="'pie'"
      />
    </div>
  </div>
</div>

            <div class="chart-desc col-md-12 col-lg-12 col-xl-2">
              <div class="stats">
                <div class="description">
                  <span class="title"> {{ $t('dashboard.invoice_chart.pending') }} </span>
                  <br>
                  <span v-if="isLoaded" class="total" style="color:#334CFF;">
                    <div v-html="invoiceGroupCount[0]"/>
                  </span>
                </div>
                <div class="description">
                  <span class="title"> {{ $t('dashboard.invoice_chart.offered') }} </span>
                  <br>
                  <span v-if="isLoaded" class="total" style="color:#E333FF;">
                    <div v-html="invoiceGroupCount[1]"/>
                  </span>
                </div>
                <div class="description">
                  <span class="title"> {{ $t('dashboard.invoice_chart.financed') }} </span>
                  <br>
                  <span v-if="isLoaded" class="total" style="color:#33FF71;">
                    <div v-html="invoiceGroupCount[2]"/>
                  </span>
                </div>
                <div class="description">
                  <span class="title"> {{ $t('dashboard.invoice_chart.prepaid') }} </span>
                  <br>
                  <span v-if="isLoaded" class="total" style="color:#F9FF33;">
                    <div v-html="invoiceGroupCount[3]"/>
                  </span>
                </div>
                <div class="description">
                  <span class="title"> {{ $t('dashboard.invoice_chart.settlement') }} </span>
                  <br>
                  <span v-if="isLoaded" class="total" style="color:#FFB233;">
                    <div v-html="invoiceGroupCount[4]"/>
                  </span>
                </div>
                <div class="description">
                  <span class="title"> {{ $t('dashboard.invoice_chart.rejected') }} </span>
                  <br>
                  <span v-if="isLoaded" class="total" style="color:#FF3F33;">
                    <div v-html="invoiceGroupCount[5]"/>
                  </span>
                </div>
                <div class="description">
                  <span class="title"> {{ $t('dashboard.invoice_chart.total_invoice') }} </span>
                  <br>
                  <span v-if="isLoaded" class="total">
                    <div v-html="totalinvoiceGroup" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card dashboard-card">
              <div class=" pt-4 card-bordy">
              <div class="card-header">
                <div class="description">
                  <h6 class="title"> {{ $t('dashboard.total_amount_funded') }} </h6>
                  <br>
                  <span v-if="isLoaded" class="total">
                    <div v-html="$utils.formatMoney(fundedAmount, defaultCurrency)"/>
                  </span>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="  col-md-6">
        <div class="card-bordy">
          <div class="card-header">
            <div class="description">
              <h6 class="title mb-0">Set Kibor Rate </h6>
              <br>
              <div class="base-input">
                <div class="form-group" style="
    display: flex;">
                   <money
                    v-model="formData.credit_limit"
                    v-bind="customerCurrency"
                    class="input-field mr-2"
                  /><base-button
                  style="margin-left: auto;"
                  size="large"
                  icon="save"
                  color="theme"
                  @click="setKiborAmountfun()"
                  type="submit"
                >
                  {{ $t('general.save') }}
                </base-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import PieChart from '../../components/chartjs/PieChart'
import BarChart from '../../components/chartjs/BarChart'
import DollarIcon from '../../components/icon/DollarIcon'
import ContactIcon from '../../components/icon/ContactIcon'
import InvoiceIcon from '../../components/icon/InvoiceIcon'
import EstimateIcon from '../../components/icon/EstimateIcon'
export default {
  components: {
    PieChart,
    BarChart,
    DollarIcon,
    ContactIcon,
    InvoiceIcon,
    EstimateIcon},
  data () {
    return {
      hoverBgColors: [],
      bgColors: ['#334CFF', '#E333FF', '#33FF71', '#F9FF33', '#FFB233', '#FF3F33'],
      bgCreditLimitColors: ['#33FF71', '#FF3F33'],
      CrditLimitLabels: null,
      labels: ['Pending', 'Offered', 'Financed', 'Prepaid', 'Settlement', 'Rejected'],
      isLoaded: false,
      years: ['This year', 'Previous year'],
      selectedYear: 'This year',
      selectedCustomer: null,
      updateChart: false,
      CreditLimitData: [],
      fundedAmount: 0,
      total_credit_limit: 0,
      formData: {
        credit_limit:0
      }
    }
  },
  computed: {
    ...mapGetters('funderDashboard', [
      'getInvoices',
      'getContacts',
      'invoiceGroupCount'
    ]),
    ...mapGetters('customer', [
      'customers'
    ]),
    ...mapGetters('currency', [
      'defaultCurrency'
    ]),
    totalinvoiceGroup () {
      return this.invoiceGroupCount.reduce((acc, item) => acc + item, 0)
    },
    customerCurrency () {
      if (this.customerCurrencyDetail) {
        return {
          decimal: this.customerCurrencyDetail.decimal_separator,
          thousands: this.customerCurrencyDetail.thousand_separator,
          prefix: this.customerCurrencyDetail.symbol + ' ',
          precision: this.customerCurrencyDetail.precision,
          masked: false
        }
      } else {
        return this.defaultCurrencyForInput
      }
    },
    customerOption () {
      let customerArray = this.customers.slice()
      customerArray.unshift({'id': null, 'company_name': 'All'})
      return customerArray
    }
  },
  watch: {
    selectedCustomer(newCustomer) {
    if (newCustomer != null) {
      this.updateChart = false;
      this.CreditLimitData = [];
      const params = { user_id: newCustomer.id }; // Pass user-specific params
      this.loadData(params);
    } else {
      this.loadData(); // Call loadData without user-specific params
    }
  }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('funderDashboard', [
      'loadData',
      'setKiborAmount'
    ]),
    async loadData(params = {}) {
  params = { ...this.formData, ...params };

  try {
    this.isLoaded = false;

    let res = await this.$store.dispatch('funderDashboard/loadData', params);

    this.updateChart = true;
    this.CreditLimitLabels = res.data.credit_limit_data.labels;
    this.total_credit_limit = res.data.credit_limit_data.total_credit_limit; // No need to divide
    this.CreditLimitData = res.data.credit_limit_data.chart; // No need to divide
    this.fundedAmount = res.data.fundedAmount;
    console.log("Chart Data Before Rendering:", this.CreditLimitData);

    this.formData.credit_limit = res.data.kiborAmount;

  } catch (error) {
    console.error("Error loading data:", error);
    this.updateChart = false;
  } finally {
    this.isLoaded = true;
  }
}

,
    async setKiborAmountfun () {
      let params = {
        ...this.formData
      }
      let res = await this.setKiborAmount( params)
      window.toastr['success'](this.$tc('general.update_kibor'))
    }
  }
}
</script>
